import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { DisclaimerContainer, StyledCollapse } from './styled';

export const Disclaimer = () => {
  const { t } = useTranslation('pages/pageInterwill', { keyPrefix: 'instructions' });

  return (
    <DisclaimerContainer>
      <StyledCollapse
        expandIconPosition="end"
        expandIcon={({ isActive }) => (
          <Icon name={isActive ? 'minus' : 'plus'} size="s20" color={COLORS.systemSky200} />
        )}
      >
        <StyledCollapse.Panel key="disclaimer" header={t('disclaimer.title')}>
          <p>{t.rich('disclaimer.subtitle')}</p>
          <p>{t.rich('disclaimer.content')}</p>
        </StyledCollapse.Panel>
      </StyledCollapse>
    </DisclaimerContainer>
  );
};
